import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import i18next from "i18next";
import ICU from "i18next-icu";
import { I18nextProvider } from "react-i18next";
const initI18n = async () => {
    // Basic i18n initialization with ICU
    await i18next.use(ICU).init({
        lng: "en",
        fallbackLng: "en",
        interpolation: { escapeValue: false },
        resources: {
            en: { translation: { hello: "Hello, {name}!" } },
            es: { translation: { hello: "¡Hola, {name}!" } },
        },
    });
    return i18next;
};
export const I18nProvider = ({ children }) => {
    const [ready, setReady] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        initI18n()
            .then(() => setReady(true))
            .catch((err) => {
            console.error("Failed to initialize i18n:", err);
            setError(err instanceof Error ? err : new Error("Unknown i18n initialization error"));
        });
    }, []);
    if (error) {
        return (_jsxs("div", { role: "alert", style: { padding: "20px", color: "red" }, children: [_jsx("h2", { children: "Translation System Error" }), _jsx("p", { children: "Failed to initialize the translation system. Please refresh the page." }), _jsxs("details", { children: [_jsx("summary", { children: "Error details" }), _jsx("pre", { children: error.message })] })] }));
    }
    if (!ready)
        return null;
    return _jsx(I18nextProvider, { i18n: i18next, children: children });
};
